// extracted by mini-css-extract-plugin
export default {"propertyEditor":"style_propertyEditor__vypXQ","placeholder":"style_placeholder__dqiOr","properties":"style_properties__b5HPx"};